import '.x{width:100%;}.ssr-plugin'
import '.ep{padding-inline:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.cs{position:sticky;}.ssr-plugin'
import '.ct{top:0px;}.ssr-plugin'
import '.cu{z-index:10;}.ssr-plugin'
import '.fy{background:var(--nav-bg);}.ssr-plugin'
import '.gw{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.e3{flex:1 1 auto;}.ssr-plugin'
import '.fu{overflow-x:auto;}.ssr-plugin'
import '.b3{min-width:0px;}.ssr-plugin'
import { useMemo } from 'react'
import { styled } from 'inlines'
import { TabsGroup } from '@app/components/core/tabs/Tabs'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import useMediaQuery from '@app/util/useMediaQuery'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import {
  regionalPageLayoutTabs,
  regionTabs,
} from '@app/pages/discover/regions/constants'
import type { RegionFeatures } from '@schema/featureToggle'
import { useRegionalLayoutTabAvailability } from '@app/pages/discover/regions/regionalPage/useRegionalLayoutTabAvailability'
import { isRegionalLayoutTabAvailable } from '@app/pages/discover/regions/regionalPage/isRegionalLayoutTabAvailable'
import { TextLink } from '@app/components/core/link/TextLink'
import { pages } from '@app/util/links'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import { navigate } from 'wouter/use-browser-location'
import { useRegionalHeaderScroll } from '@app/pages/discover/regions/regionalPage/RegionalHeaderScrollContext'

const REGION_NAME_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const layoutTabKeys = Object.values(regionalPageLayoutTabs)

export type RegionalNavBarProps = {
  region: RegionViewModel
  tab: RegionFeatures
}

export const RegionalNavBar = ({ region, tab }: RegionalNavBarProps) => {
  const isMobile = useMediaQuery()
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.regionPage
  const { context } = useRegionalLayoutTabAvailability(region)
  const { showRegionName } = useRegionalHeaderScroll()
  const isOverviewTab = tab === regionTabs.overview
  const shouldShowRegionName = !isOverviewTab || showRegionName

  const tabs = useMemo(
    () =>
      layoutTabKeys.map((key) => ({
        value: key,
        label: translations[key],
        isVisible: isRegionalLayoutTabAvailable(region, key, context),
      })),
    [translations, region, context],
  )

  const handleSelectTab = (key: RegionFeatures) => {
    navigate(pages.regionPageNew(region.slug, key))
  }

  return (
    <nav className="x ep d k cs ct cu fy gw"
    >
      <ResponsiveContainer
        style={{
          background: 'var(--nav-bg)',
          display: 'flex',
          justifyContent: shouldShowRegionName ? 'space-between' : 'flex-end',
          alignItems: 'center',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          minHeight: '3.5rem',
          gap: isMobile ? '0.5rem' : '1rem',
        }}
      >
        {shouldShowRegionName ? (
          <TextLink
            to={pages.regionPageNew(region.slug)}
            textStyle={{
              fontFamily: 'var(--font-heading)',
              ...getTitleLevelStyle(3, isMobile),
              whiteSpace: 'nowrap',
            }}
            containerStyle={{
              textDecoration: 'none',
              animation: REGION_NAME_APPEAR_ANIMATION,
            }}
          >
            {region.name}
          </TextLink>
        ) : null}

        <div className="e3 d fu b3"
          style={{
            justifyContent: isMobile ? 'flex-start' : 'flex-end',}}
        >
          <TabsGroup
            selectedTab={tab}
            onSelectTab={handleSelectTab}
            maxVisibleTabs={isMobile ? 3 : 6}
            tabs={tabs}
            tabItemStyle={{
              padding: isMobile ? '1rem 0.75rem' : '1.25rem 1rem',
            }}
          />
        </div>
      </ResponsiveContainer>
    </nav>
  )
}
